// src/app/services/change-password-service.ts
import { apiFetch } from "@/api/api-fetch";

/**
 * POST /auth/change-password
 */
export async function changePassword(
  currentPassword: string,
  newPassword: string,
): Promise<void> {
  await apiFetch("/auth/change-password", {
    method: "POST",
    body: JSON.stringify({
      current_password: currentPassword,
      new_password:     newPassword,
    }),
  });
}